<template>
    <div class="mb-3">
        <input hidden :name="field_name" :value="selected" class="form-control" />
        <div class="position-relative">
            <div v-if="selectedImage">
                <div class="position-absolute btn btn-sm btn-danger mt-3" @click="selected = null" style="right: 15px"><i class="fas fa-times"></i></div>
                <img class="img-fluid" alt="background" :src="selected"/>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center bg-light" style="padding: 28% 1px">
                {{ $t('js.backend.image_selector.select_image') }}
            </div>
        </div>
        <div class="d-flex overflow-auto">
            <a v-for="image in images" class="overflow-hidden" style="min-width: 180px;max-height:100px;" @click.prevent="setSelected(image)" href="#">
                <img style="width:180px" alt="background" :src="image"/>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ImageSelector",
        props: {
            images: Array,
            selected: String,
            field_name: String
        },
        computed: {
            selectedImage(){
                if(this.selected === null)
                    return null

                return this.images.find(i => i === this.selected)
            }
        },
        methods:{
            setSelected(image){
                this.selected = image
            }
        }
    }
</script>